'use client'
import { createContext, useContext } from "react";
const TableHeadContext = /*#__PURE__*/ createContext({
    sticky: false,
    interactive: false,
    isHeaderRow: false
});
const useTableHeadContext = ()=>useContext(TableHeadContext);
export { TableHeadContext, useTableHeadContext };
